<template>
  <div v-loading="loading" element-loading-text="拼命加载中" style="height: 100%;">
    <el-table :data="tableData" style="width: 100%" height="calc(100% - 70px)">
      <el-table-column prop="sign_begin" label="签约开始" width="85"/>
      <el-table-column prop="sign_end" label="签约截至" width="85"/>
      <el-table-column prop="suspend_date" label="中止日期" width="85">
        <template v-slot="{row:{suspend_date}}">
          <span v-if="suspend_date" style="color: red">{{ suspend_date }}</span>
          <span v-else>-</span>
        </template>
      </el-table-column>
      <el-table-column prop="policy_alias" label="年框政策" min-width="180" show-overflow-tooltip/>
      <el-table-column prop="level_customer" label="客户等级" width="85"/>
      <el-table-column prop="level_combine" label="集团等级" width="85"/>
      <el-table-column prop="order_money" label="投放金额" width="85"/>
      <el-table-column prop="rebate_money" label="返点金额" width="85"/>
      <el-table-column prop="discount_money" label="优惠金额" width="85"/>
      <el-table-column prop="apply.pay_method" label="付款方式" width="85" show-overflow-tooltip>
        <template slot-scope="{row}">
          {{
            row.apply && row.apply.pay_method && row.apply.pay_method_sub ? row.apply.pay_method + '-' + row.apply.pay_method_sub : (row.apply && row.apply.pay_method ? row.apply.pay_method : '-')
          }}
        </template>
      </el-table-column>
      <el-table-column prop="apply.charge_person" label="最高级别负责人" width="120"/>
      <el-table-column prop="apply.post" label="职位" width="85"/>
      <el-table-column prop="apply.creator" label="申请人" width="65" show-overflow-tooltip/>
      <el-table-column prop="created_at" label="审核时间" width="100" show-overflow-tooltip/>
      <el-table-column label="说明" min-width="110" align="center" show-overflow-tooltip>
        <template slot-scope="scope">
          <span v-if="scope.row.apply&&scope.row.apply.creator_remark">申请人：{{ scope.row.apply.creator_remark }}；&nbsp;</span>
          <span v-if="scope.row.apply&&scope.row.apply.audit_remark">审核人：{{ scope.row.apply.audit_remark }}</span>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
        background
        :current-page="queryParams.page"
        :page-size="queryParams.page_size"
        layout="prev, pager, next"
        :total="queryParams.total"
        @current-change="handleCurrentChange"
        style="margin-top: 10px"
    />
  </div>
</template>

<script>
import {yearFrameValidList} from "@/api/customerYearFrame";

export default {
  name: "table-valid",
  components: {},
  props: {
    customerId: {
      type: [String, Number],
      required: true
    },
  },
  data() {
    return {
      loading: false,
      tableData: [],
      queryParams: {
        customer_id: [this.customerId],
        page: 1,
        page_size: 10,
        total: 0,
      }
    }
  },
  created() {
    this.init()
  },
  methods: {
    async init() {
      this.loading = true
      await this.getTableData()
      this.loading = false
    },
    handleCurrentChange(val) {
      this.queryParams.page = val
      this.getTableData()
    },
    async getTableData() {
      const response = await yearFrameValidList(this.queryParams)
      if (!response.success) {
        this.showToast({h: this, icon: "el-icon-error", text: response.message, duration: 3000});
        return;
      }

      const array = response.model.data || [];
      array.map(datum => {
        datum.vue_audit = datum.status
        datum.vue_audit_remark = null
      })
      this.queryParams.total = response.model.total
      this.tableData = array;
    },
  }
}
</script>

<style scoped>

</style>
